import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import './index.css';
import App from './app';
import { store } from './store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/query-client';
initializeIcons();

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </Provider>
    </BrowserRouter>,

    document.getElementById('root'),
);
